const keyMap = {
  'Bank Name': ['bankName', 'bank_name', 'bank'],
  'Branch': ['branch'],
  'Full Name': ['fullName', 'full_name', 'name', 'applicant_name'],
  'Title of Account': ['titleOfAccount', 'title_of_account', 'account_no', 'accountNumber'],
  'Mailing Address': ['mailingAddress', 'mailing_address', 'address'],
  'City District': ['cityDistrict', 'city_district', 'city'],
  'Postal Code': ['postalCode', 'postal_code', 'zip_code'],
  'Country': ['country', 'nationality'],
  'Nature of Account': ['natureOfAccount', 'nature_of_account', 'account_nature'],
  'Type of Account': ['typeOfAccount', 'type_of_account', 'accountType', 'account_type'],
  'Currency of Account': ['currencyOfAccount', 'currency_of_account', 'currency'],
  'Nature of Business': ['natureOfBusiness', 'nature_of_business', 'business_nature'],
  'Sales Tax No': ['salesTaxNo', 'sales_tax_no', 'sales_tax', 'salesTax'],
  'N T N': ['ntn', 'NTN', 'national_tax_number', 'nationalTaxNumber', 'taxId', 'tax_id'],
  'Full Name As Per ID': ['fullNameAsPerID', 'full_name_as_per_id', 'name_as_per_id'],
  'Date of Birth': ['dateOfBirth', 'date_of_birth', 'dob'],
  'Place of Birth': ['placeOfBirth', 'place_of_birth', 'birth_place'],
  'CNIC Number': ['cnicNumber', 'cnic_number', 'CNICNumber', 'nicNumber', 'id_number', 'national_id', 'idNumber'],
  'Date of Issue': ['dateOfIssue', 'date_of_issue', 'issue_date'],
  'Expiry Date': ['expiryDate', 'expiry_date', 'expiration_date'],
  'Father\'s/Husband\'s Name': ['fatherHusbandName', 'fathers_husband_name', 'father_husband_name', 'father_name', 'husband_name'],
  'Mother\'s Maiden Name': ['mothersMaidenName', 'mothers_maiden_name', 'mother_maiden_name', 'motherMaidenName'],
  'Passport Number': ['passportNumber', 'passport_number', 'passport'],
  'Nationality': ['nationality'],
  'Residence Status': ['residenceStatus', 'residence_status'],
  'Permanent Residential Address': ['permanentResidentialAddress', 'permanent_residential_address', 'permanent_address'],
  'Business/Profession': ['businessProfession', 'business_profession', 'profession'],
  'Name/Address of Employer/Business': ['nameAddressEmployerBusiness', 'name_address_employer_business', 'employerBusinessName', 'employer_business'],
  'Office Phone': ['telephoneNumbers.office', 'officePhone', 'office_phone', 'phone.work', 'work_phone'],
  'Mobile Phone': ['telephoneNumbers.mobile', 'mobilePhone', 'mobile_phone', 'phone.mobile'],
  'Residence Phone': ['telephoneNumbers.residence', 'residencePhone', 'residence_phone', 'phone.residence'],
  'Fax': ['telephoneNumbers.fax', 'fax', 'fax_number'],
  'Email Address': ['emailAddress', 'email_address', 'email'],
  'Date': ['date', 'created_date', 'submission_date'],
  
};

export default keyMap;